// Widget Scripts
import videoWidget from './js/widgets/videoWidget';
import swiperWidgetMainFeature from './js/widgets/swiperWidgetMainFeature';
import swiperWidgetGallery1 from './js/widgets/swiperWidgetGallery1';
import swiperWidgetGallery2 from './js/widgets/swiperWidgetGallery2';
import swiperWidgetGallery3 from './js/widgets/swiperWidgetGallery3';
import swiperWidgetGallery4 from './js/widgets/swiperWidgetGallery4';
import cardWidget from './js/widgets/cardWidget.js';
import cardWidgetSponsors from './js/widgets/cardWidgetSponsors.js';
import { instafeed } from './js/widgets/socialNetworkWidget';
import AOS from 'aos';
import 'aos/dist/aos.css';


// Custom Theme Scripts
import './js/localjs.js';
// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    swiperWidgetGallery1();
    swiperWidgetGallery2();
    swiperWidgetGallery3();
    swiperWidgetGallery4();
    cardWidget();
    instafeed(true);

    if ($("body").hasClass("eventsMode")) {
      $(window).load(function () {
        videoWidget();
      })
    } else {
      swiperWidgetMainFeature();
    }
  });
}
$(document).ready(function () {
  cardWidgetSponsors();

  setTimeout(() => {
    AOS.init({
      anchorPlacement: 'bottom-bottom',
      animatedClassName: 'aos-animate',
      initClassName: 'aos-init',
    });
  }, 3000)
})
